module.exports = __webpack_public_path__ + "4b5b88eb5628a54ea9ceb07835e495c5.png";